import { useEffect, useState } from "react";

const initOffset = typeof window !== "undefined" ? window.scrollY : 0;

const useScrollPosition = () => {
  const [offset, setOffset] = useState(initOffset);

  const handleScroll = () => {
    const position = window.scrollY;
    setOffset(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { offset };
};

export default useScrollPosition;
